import React, { useState } from 'react';
import { Form, InputNumber, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { FormPageLayout } from '../../components/FormPageLayout';
import { useAutoSave } from '../../hooks/useAutoSave';

const RateTierEdit: React.FC = () => {
    const { channelId, id } = useParams<{ channelId: string; id: string }>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const isNew = !id || id === 'new';

    const { triggerSave, state: saveState } = useAutoSave<any>({
        onSave: async (data) => {
            message.success(isNew ? '运费阶梯已创建' : '已保存');
            if (isNew) {
                navigate(`/shipping-management/edit/${channelId}`);
            }
        },
        delay: 1000,
        enabled: !isNew,
        showMessage: true
    });

    const handleValuesChange = (_: any, allValues: any) => {
        if (!isNew) {
            triggerSave(allValues);
        }
    };

    const handleManualSave = async () => {
        try {
            const values = await form.validateFields();
            message.success('运费阶梯已创建');
            navigate(`/shipping-management/edit/${channelId}`);
        } catch (error) {
            // Validation error
        }
    };

    const getSaveStatus = () => {
        if (saveState.isSaving) return 'saving';
        if (saveState.hasUnsavedChanges) return 'hasChanges';
        if (saveState.lastSavedAt) return 'saved';
        return 'idle';
    };

    return (
        <FormPageLayout
            title={isNew ? '添加运费阶梯' : '编辑运费阶梯'}
            breadcrumbs={[
                { title: '运费管理', path: '/shipping-management' },
                { title: '渠道编辑', path: `/shipping-management/edit/${channelId}` },
                { title: isNew ? '添加阶梯' : '编辑阶梯' }
            ]}
            saveStatus={getSaveStatus()}
            showSaveButton={isNew}
            onSave={handleManualSave}
            saving={loading}
        >
            <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
                <Form.Item name="min_weight" label="最小重量(kg)" rules={[{ required: true }]}>
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} />
                </Form.Item>
                <Form.Item name="max_weight" label="最大重量(kg)" tooltip="留空表示无上限">
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} />
                </Form.Item>
                <Form.Item name="price_per_kg" label="单价(¥/kg)" rules={[{ required: true }]}>
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} prefix="¥" />
                </Form.Item>
                <Form.Item name="base_fee" label="起步价(¥)" initialValue={0}>
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} prefix="¥" />
                </Form.Item>
            </Form>
        </FormPageLayout>
    );
};

export default RateTierEdit;
